
<div mat-dialog-content>
  <iframe
    [src]="safeURL"
    frameborder="0"
    allowfullscreen
    class="customIframe"
  ></iframe>
</div>